import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CountryLabels } from '@shared/domain/common/country';
import { CreateOrderModel } from 'retail/app/orders/models/create-order.model';
import { OrdersService } from 'retail/app/orders/providers/orders.service';
import { VAT } from 'shared-ui/models/vat';

@Component({
  selector: 'retail-final',
  templateUrl: './final.component.html',
  styleUrls: ['./final.component.scss'],
})
export class FinalComponent implements OnInit {
  readonly vat = VAT;
  readonly CountryLabels = CountryLabels;
  @Output() back = new EventEmitter();
  @Output() next = new EventEmitter();
  order?: CreateOrderModel;
  checked = false;
  submitted = false;

  constructor(private ordersService: OrdersService) {}

  ngOnInit(): void {
    this.order = this.ordersService.loadFullOrder();
  }

  continue() {
    this.submitted = true;
    if (this.checked) {
      this.next.emit();
    }
  }
}
